/* eslint-disable */
import VuePdfEmbed from "vue-pdf-embed";
import { onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import store from "@/store";
import VPagination from "@hennge/vue3-pagination";
import * as XLSX from "xlsx";



export default {
  name: "eConsentDashboard",
  components: { VuePdfEmbed, VPagination },
 data() {
  return {
    baseapi: process.env.VUE_APP_Service_URL,
    subject:{},
    subjects: [],
    icfForms: [], 
    campaign: null,
        consentCounts: {
      all: 0,
      consented: 0,
      pending: 0,
      reConsentDue: 0,
      pending:0,
      dissented: 0,
      notStarted: 0
    },
    pageNumber: 1,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,

    currentPage: 1,

    isDocumentLoading: false,
    isExporting: false,

    currentFilter: 'all',
    currentSearch: '',
     chipCounts: {
      all: 0,
      consented: 0,
      pending: 0,
      reconsent: 0,
      dissented: 0,
      'not-started': 0
    },
statusConfig: {
  consented: { label: 'Consented', cls: 'b-consented' },
  pending:   { label: 'Pending', cls: 'b-pending' },
  reconsent: { label: 'Re-consent due', cls: 'b-reconsent' },
  dissented: { label: 'Dissented', cls: 'b-dissented' },
     'not-started': { label: 'Not Started', cls: 'b-notstarted' },
},


  }
},
  mounted() {
    
    //store.dispatch("setPatientNavbar", true);
    window.setFilter = this.setFilter;
    window.filterTable = this.filterTable;
    window.exportCSV = this.exportCSV;
    window.sendAll = this.sendAll;
    this.getConsentList();

  this.getICFForms();
  this.getLatestCampaign();
  this.getConsentCounts();
   window.addEventListener("studyIdChanged", this.handleStudyIdChanged);
  },
  beforeUnmount() {
    ['setFilter', 'filterTable', 'exportCSV', 'sendAll'].forEach((fn) => {
      if (window[fn] === this[fn]) {
        delete window[fn];
      }
    });
     window.removeEventListener("studyIdChanged", this.handleStudyIdChanged);
  },
computed: {
filteredSubjects() {
  const q = this.currentSearch.toLowerCase();
  return this.subjects.filter(s => {
    let matchFilter = true;
    if (this.currentFilter === 'reconsent') {
      matchFilter = s.reConsentRequired === true;
    } else if (this.currentFilter !== 'all') {
      matchFilter = s.outcome === this.currentFilter;
    }

    const matchSearch =
      !q ||
      (s.subjectId || '').toLowerCase().includes(q) ||
      (s.siteCode || '').toLowerCase().includes(q) ||
      (s.consentOutcome || '').toLowerCase().includes(q);

    return matchFilter && matchSearch;
  });
}
},
  methods: {
     handleStudyIdChanged(event) {
      // Reset to page 1 and keep current filter
      this.getConsentList(1, this.currentFilter);
      this.getICFForms();
      this.getLatestCampaign();
      this.getConsentCounts();
    },
// async getConsentList(page = this.currentPage, filter = this.currentFilter) {
//   try {
//     const studyId = store.getters.getStudyIs;
//     const params = {
//       Studyid: studyId,
//       pageindex: page,
//       pageSize: this.pageSize
//     };
//     if (filter && filter !== 'all') {
//       const outcomeMap = {
//         consented: 'Consented',
//         pending: 'Pending',
//         dissented: 'Dissented'
//       };
//       if (outcomeMap[filter]) {
//         params.ConsentOutcome = outcomeMap[filter];
//       }
    
//     }

//     const response = await axios.get(
//       `${this.baseapi}/management/patient/listpatientwithconsent`,
//       { params, headers: { Authorization: `Bearer ${store.getters.getIdToken}` } }
//     );

//     const data = response.data;
//     let subjects = (data.results || []).map(item => {
//      let outcome = (item.consentOutcome || '').toLowerCase();

// if (!outcome) {
//   outcome = "notstarted";
// }

// if (outcome === 'declined') {
//   outcome = 'dissented';
// }

// if (outcome === 'consented') {
//   outcome = 'consented';
// }

//       return {
//         ...item,
//         icfVersion: item.assignedICFVersion
//           ? `v${item.assignedICFVersion}`
//           : item.assignedICF || "",
//         signedDate: item.subjectSignedDate ? this.formatDate(item.subjectSignedDate) : null,
//         outcome,
//         consentOutcome: item.consentOutcome || "Not Started",

//         reconsent: item.reConsentRequired ? 'Required' : null,
//         investigatorSignedDate: item.investigatorSignedDate ? this.formatDate(item.investigatorSignedDate) : null,
//         investigatorEmail: item.investigatorEmail,
//         daysOpen: item.daysOpen || 0
//       };
//     });
//     if (filter === 'reconsent') {
//       subjects = subjects.filter(s => s.reConsentRequired === true);
//     }

//     this.subjects = subjects;
//     this.totalCount = data.totalCount || 0;
//     this.totalPages = Math.max(1, Math.ceil(this.totalCount / (data.pageSize || this.pageSize)));
//     this.currentPage = page;
//     await this.getChipCounts(studyId);

//   } catch (err) {
//     console.error("Error fetching consent list:", err);
//   }
// }
async getConsentList(page = this.currentPage, filter = this.currentFilter) {
  try {
    const studyId = store.getters.getStudyIs;
    let params = {
      Studyid: studyId,
      pageindex: page,
      pageSize: this.pageSize
    };

    // For client‑side filters – fetch all records
    const isClientFilter = (filter === 'reconsent' || filter === 'not-started');
    if (isClientFilter) {
      params.pageSize = 9999;     // large number to get all
      params.pageindex = 1;
    }

    // API‑supported filters (server side)
    const outcomeMap = {
      consented: 'Consented',
      pending: 'Pending',
      dissented: 'Dissented'
    };
    if (filter && outcomeMap[filter]) {
      params.ConsentOutcome = outcomeMap[filter];
    }

    const response = await axios.get(
      `${this.baseapi}/management/patient/listpatientwithconsent`,
      { params, headers: { Authorization: `Bearer ${store.getters.getIdToken}` } }
    );

    const data = response.data;
    let subjects = (data.results || []).map(item => {
      let outcome = (item.consentOutcome || '').toLowerCase();
      if (!outcome) outcome = "not-started";
      if (outcome === 'declined') outcome = 'dissented';
      if (outcome === 'consented') outcome = 'consented';
      return {
        ...item,
        icfVersion: item.assignedICFVersion ? `v${item.assignedICFVersion}` : item.assignedICF || "",
        signedDate: item.subjectSignedDate ? this.formatDate(item.subjectSignedDate) : null,
        outcome,
        consentOutcome: item.consentOutcome || "Not Started",
        reconsent: item.reConsentRequired ? 'Required' : null,
        investigatorSignedDate: item.investigatorSignedDate ? this.formatDate(item.investigatorSignedDate) : null,
        investigatorEmail: item.investigatorEmail,
        daysOpen: item.daysOpen || 0
      };
    });

    // Apply client‑side filters
    if (filter === 'reconsent') {
      subjects = subjects.filter(s => s.reConsentRequired === true);
    } else if (filter === 'not-started') {
      subjects = subjects.filter(s => s.outcome === 'not-started');
    }

    // Handle front‑end pagination for client‑side filters
    if (isClientFilter) {
      const totalMatching = subjects.length;
      this.totalCount = totalMatching;
      this.totalPages = Math.max(1, Math.ceil(totalMatching / this.pageSize));
      // Ensure page is within bounds
      if (page > this.totalPages) page = this.totalPages;
      const start = (page - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.subjects = subjects.slice(start, end);
      this.currentPage = page;
    } else {
      // Normal server‑side pagination
      this.subjects = subjects;
      this.totalCount = data.totalCount || 0;
      this.totalPages = Math.max(1, Math.ceil(this.totalCount / (data.pageSize || this.pageSize)));
      this.currentPage = page;
    }

    await this.getChipCounts(studyId);
  } catch (err) {
    console.error("Error fetching consent list:", err);
  }
}
,
async getICFForms() {
  this.showLoading = true;
 
  try {
     const studyId = store.getters.getStudyIs;
  
    
    const url = `${this.baseapi}/management/patientdocument/listicfformsbystudy?studyId=${studyId}`;
    const response = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + store.getters.getIdToken,
        "Content-Type": "application/json",
      },
    });

    if (response.data && response.data.results) {
      this.icfForms = response.data.results.map(f => ({
        id: f.id,
        version: `v${f.versionNumber}`,
        title: f.formName,
       
      }));
    } else {
      this.icfForms = [];
    }
  } catch (err) {
    console.error("Error fetching ICF forms:", err);
    this.icfForms = [];
  } finally {
    this.showLoading = false;
  }
},
async getLatestCampaign() {
  try {
    const studyId = store.getters.getStudyIs;
    const url = `${this.baseapi}/management/reconsentcampaign/getconsentcampaignstatus?studyId=${studyId}`;

    const response = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + store.getters.getIdToken,
        "Content-Type": "application/json"
      }
    });

    const campaigns = response.data || [];

    if (campaigns.length > 0) {
      campaigns.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const latest = campaigns[0];

      this.campaign = {
        name: latest.campaignName,
        createdAt: this.formatDate(latest.createdAt),
        icf: `${latest.icf.icfName} - v.${latest.icf.version}`,
        total: latest.totalSubjects,
        consented: latest.consentedSubjects,
        percent: latest.totalSubjects > 0
          ? Math.round((latest.consentedSubjects / latest.totalSubjects) * 100)
          : 0
      };
    }
  } catch (err) {
    console.error("Error fetching campaign status:", err);
    this.campaign = null;
  }
},

 viewSubject(patientId) {
    const router = this.$router;
    router.push({
      path: `/subjectprofile/${patientId}`,
      query: { sourceTab: 'subject',tab: 'document' }
    });
  },
async getChipCounts(studyId) {
  try {
    const response = await axios.get(
      `${this.baseapi}/management/patient/listpatientwithconsent`,
      {
        params: { Studyid: studyId, pageindex: 1, pageSize: 9999 },
        headers: { Authorization: `Bearer ${store.getters.getIdToken}` }
      }
    );

    const results = response.data.results || [];
    this.chipCounts.all = response.data.totalCount || 0;
    this.chipCounts.consented = results.filter(
      s => (s.consentOutcome || '').toLowerCase() === 'consented'
    ).length;
    this.chipCounts.pending = results.filter(
      s => (s.consentOutcome || '').toLowerCase() === 'pending'
    ).length;
    this.chipCounts.dissented = results.filter(s => {
      const outcome = (s.consentOutcome || '').toLowerCase();
      return outcome === 'dissented' || outcome === 'declined';
    }).length;
    this.chipCounts.reconsent = results.filter(
      s => s.reConsentRequired === true
    ).length;
    this.chipCounts['not-started'] = results.filter(
      s => !s.consentOutcome || (s.consentOutcome || '').trim() === ''
    ).length;
  } catch (err) {
    console.error("Error fetching chip counts:", err);
  }
},
 goBack() {
    this.$router.go(-1);   
  },
async getConsentCounts() {
  try {
    const studyId = store.getters.getStudyIs;
    const url = `${this.baseapi}/management/patient/patientconsentcounts?Studyid=${studyId}`;

    const response = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + store.getters.getIdToken,
        "Content-Type": "application/json"
      }
    });

    this.consentCounts = response.data || this.consentCounts;
  } catch (err) {
    console.error("Error fetching consent counts:", err);
  }
},

loadPage(page){

 this.currentPage = page;

 this.getConsentList(page);

},
formatDate(dateString) {
    if (!dateString) return '-';

    const date = dateString.split("T")[0];

    const [year, month, day] = date.split("-");

    return `${day}/${month}/${year}`;
},
      // formatDate(dateString) {
      //       if (!dateString) return '-';
      //       const date = new Date(dateString);
      //       return date.toLocaleDateString();
      //   },
getConsentStatus(events) {

  if(!events || !events.length){
    return "pending";
  }

  const signedEvent = events.find(
    e => e.eventType === "SUBJECT_SIGNED"
  );

  if(signedEvent){
    return "signed";
  }

  return "pending";
},


getSignedDate(events) {

  if(!events || !events.length){
    return "—";
  }

  const signedEvent = events.find(
    e => e.eventType === "SUBJECT_SIGNED"
  );

  if(!signedEvent){
    return "—";
  }

  return new Date(
    signedEvent.eventAt
  ).toLocaleDateString();
},
    badgeHtml(status){
  const c = this.statusConfig[status];
  return `<span class="badge ${c.cls}"><span class="bdot"></span>${c.label}</span>`;
},

icfHtml(v){
  const cls = v === 'v3.0' ? 'latest' : 'old';
  return `<span class="icf-ver ${cls}">${v}</span>`;
},

daysHtml(d, status){
  if(d === 0) return '<span style="color:var(--text3);font-family:var(--mono);font-size:11px;">—</span>';
  const col = d > 14 ? 'var(--red)' : d > 7 ? 'var(--amber)' : 'var(--text2)';
  return `<span style="color:${col};font-family:var(--mono);font-size:11px;font-weight:500;">${d}d</span>`;
},
setFilter(f) {
  this.currentFilter = f;
   this.getConsentList(1, f);
},

filterTable(event) {
  this.currentSearch = event.target.value;
},
getsubject(patientid) {
  if (!this.subjects || !Array.isArray(this.subjects)) {
    return null;
  }

  return this.subjects.find(subject => subject.patientId === patientid) || null;
},
async resendNotification(patientid) {
   await this.getConsentList(this.currentPage, this.currentFilter);
   console.log("this.subjects",this.subjects);
   this.subject = this.getsubject(patientid);
   console.log("this.subject",this.subject);
  try {
    if (!this.subject || !this.subject.patientId || !this.subject.studyId) {
      alert('Missing subject data: patientId or studyId not found');
      return;
    }
    if (!this.subject.consentRecordId) {
      alert('Consent record ID is missing for this subject.');
      return;
    }

    const payload = {
      subjectID: this.subject.patientId,            
      consentRecordID: this.subject.consentRecordId, 
      studyID: this.subject.studyId
    };

    const idtoken = store.getters.getIdToken;

    const response = await axios.post(
      `${this.baseapi}/account-core/user/resendinvitation`,
      payload,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    const successMsg = response.data? response.data : "Resent successfully";
    alert(successMsg);
    await this.updateConsent(patientid);

    this.getConsentList(this.currentPage, this.currentFilter);

  } catch (err) {
    let errorMsg = "Failed to resend invitation. Please try again.";
    if (err.response?.data?.message) {
      errorMsg = err.response.data.message;
    } else if (err.response?.data?.errors) {
      const errorObj = err.response.data.errors;
      errorMsg = Object.values(errorObj).flat().join('; ');
    } else if (err.message) {
      errorMsg = err.message;
    }
    alert(errorMsg);
    console.error("Error resending notification:", err);
  }
},

async updateConsent(patientid) {
  
  const idtoken = store.getters.getIdToken;
  const studyId = store.getters.getStudyIs;
await this.getConsentList(this.currentPage, this.currentFilter);
  try {
    // get subject same way as resendNotification
    const subject = this.getsubject(patientid);

    if (!subject || !subject.patientId || !subject.studyId) {
      console.warn("Missing subject data: patientId or studyId not found");
      return;
    }

    if (!subject.consentRecordId) {
      console.warn("Consent record ID is missing for this subject");
      return;
    }

    const payload = {
      consentId: this.subject.consentRecordId,
      studyID: this.subject.studyId || studyId,
      subjectID: this.subject.patientId,
      status: "REMINDER_SENT"
    };

    await axios.put(
      `${this.baseapi}/management/patientdocument/updateconsentbysubject`,
      payload,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Consent updated successfully");

  } catch (error) {
    console.error(
      "Error updating consent status:",
      error.response?.data || error.message
    );
  }
},
async exportCSV(all = false) {
    if (this.isExporting) return;
  this.isExporting = true;
  try {
    const studyId = store.getters.getStudyIs;
    let subjects = [];

    if (all) {
     
      const response = await axios.get(`${this.baseapi}/management/patient/listpatientwithconsent`, {
        params: { Studyid: studyId, pageindex: 1, pageSize: 9999 },
        headers: { Authorization: `Bearer ${store.getters.getIdToken}` }
      });
      subjects = response.data.results || [];
    } else {
     
      subjects = this.filteredSubjects;
    }

    const rows = [
      ["Subject ID","Site","ICF Version","Consent Status","Subject Signed Date","Investigator Signed Date","Investigator","Re-consent","Days Open"],
      ...subjects.map(s => [
        s.subjectId || "",
        s.siteCode || "",
        s.icfVersion || s.assignedICF || "",
        s.consentOutcome || "",
        s.signedDate || (s.subjectSignedDate ? this.formatDate(s.subjectSignedDate) : ""),
       s.investigatorSignedDate
      ? this.formatDate(s.investigatorSignedDate)
      : "",
        s.investigatorEmail || "",
        s.reConsentRequired ? "Required" : "",
        s.daysOpen > 0 ? `${s.daysOpen} days` : ""
      ])
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Consent Register");
    XLSX.writeFile(workbook, all ? "Subject Consent Register (All).xlsx" : "Subject Consent Register (Page).xlsx");
  } catch (err) {
    console.error("Error exporting subjects:", err);
  }
  finally {
    this.isExporting = false;
  }
}
,
// exportCSV(){
//   const rows = [
//     [
//       "Subject ID",
//       "Site",
//       "ICF Version",
//       "Consent Status",
//       "Subject Signed Date",
//       "Investigator Signed Date",
//       "Investigator",
//       "Re-consent",
//       "Days Open"
//     ],
//     ...this.filteredSubjects.map(s => [
//       s.subjectId || "—",
//       s.siteCode || "—",
//       s.icfVersion || "—",
//       this.statusConfig[s.consentOutcome]?.label || s.consentOutcome || "—",
//       s.signedDate || "—",
//       s.investigatorSignedDate || "—",
//       s.investigatorEmail || "—",
//       s.reconsent || "—",
//       s.daysOpen > 0 ? `${s.daysOpen}d` : "—"
//     ])
//   ];

//   const worksheet = XLSX.utils.aoa_to_sheet(rows);
//   worksheet["!cols"] = [
//     { wch: 16 },
//     { wch: 14 },
//     { wch: 28 },
//     { wch: 18 },
//     { wch: 20 },
//     { wch: 24 },
//     { wch: 30 },
//     { wch: 14 },
//     { wch: 12 }
//   ];

//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Consent Register");
//   XLSX.writeFile(workbook, "Subject Consent Register.xlsx");
// },

sendAll(){
  const pending = this.subjects.filter(s=>s.status==='pending'||s.status==='reconsent'||s.status==='overdue');
  alert(`Reminder sent to ${pending.length} subjects requiring action.`);
}

    },

     setup() {
        
        const router = useRouter();
         onBeforeMount(async () => {
            
            const pageWrapper = document.getElementById("page-wrapper");
            if (pageWrapper) pageWrapper.style.width = "100%";
        });

        router.beforeEach((to, from, next) => {
            console.log("name is",to.name)
            const pageWrapper = document.getElementById("page-wrapper");
            if (!pageWrapper) {
                next();
                return;
            }
            if (to.name != "profileSettings" && to.name != "eConsentDashboard") {
                
                pageWrapper.style.removeProperty("width");
            } else {
                pageWrapper.style.width = "100%";
            }
            next();
        });
     },


     

};
